import PropTypes from "prop-types";
import { useEffect } from "react";
import Card from "../../components/Cards/Card";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import CardWrapper from "../../components/LayoutCardsWrapper/CardWrapper";
import LayoutCardsWrapper from "../../components/LayoutCardsWrapper/LayoutCardsWrapper";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useQlik } from "../../context/Qlik";

function ManagementDesktop({ app, config }) {
  const { container } = config.management;
  const { setSwitchOnDemand } = useQlik();

  useEffect(() => {
    setSwitchOnDemand(false);
  }, [setSwitchOnDemand]);

  return (
    <div className="app management" style={{ height: "150%" }}>
      <div className="appContent">
        <LayoutCardsWrapper>
          {/* Análise PDVs Positivados */}
          <div style={{ width: "100%", paddingInline: "10px" }}>
            <ComboHeader
              reference={{ title: { hard: container[0].name } }}
            ></ComboHeader>
          </div>
          <CardWrapper customStyle={{ height: "40%" }}>
            <Card
              expandable
              exportTable
              app={app}
              exportContainer
              exportTableId={container[0].cards[0].nativeObject.id}
              header={{
                hardTitle: container[0].cards[0].title.hardTitle,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key={container[0].cards[0].nativeObject.valueId}
                reference={{
                  id: container[0].cards[0].nativeObject.id,
                }}
              />
            </Card>
          </CardWrapper>

          {/* Filtros */}
          <div style={{ width: "100%", paddingInline: "10px" }}>
            <ComboHeader
              reference={{ title: { hard: container[3].name } }}
            ></ComboHeader>
          </div>
          <CardWrapper customStyle={{ height: "5%" }}>
            <Card
              app={app}
              header={{
                hardTitle: container[3].cards[0].title.hardTitle,
              }}
              style={{ width: "100%", height: "100%", padding: "10px" }}
            >
              <NativeObject
                app={app}
                key={container[3].cards[0].nativeObject.valueId}
                reference={{
                  id: container[3].cards[0].nativeObject.id,
                }}
              />
            </Card>
            <Card
              app={app}
              header={{
                hardTitle: container[3].cards[1].title.hardTitle,
              }}
              style={{ width: "100%", height: "100%", padding: "10px" }}
            >
              <NativeObject
                app={app}
                key={container[3].cards[1].nativeObject.valueId}
                reference={{
                  id: container[3].cards[1].nativeObject.id,
                }}
              />
            </Card>
          </CardWrapper>

          {/* Análise Completa */}
          <div style={{ width: "100%", paddingInline: "10px" }}>
            <ComboHeader
              reference={{ title: { hard: container[1].name } }}
            ></ComboHeader>
          </div>
          <CardWrapper customStyle={{ height: "30%" }}>
            <Card
              expandable
              exportTable
              app={app}
              exportContainer
              exportTableId={container[1].cards[0].nativeObject.id}
              header={{
                hardTitle: container[1].cards[0].title.hardTitle,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key={container[1].cards[0].nativeObject.valueId}
                reference={{
                  id: container[1].cards[0].nativeObject.id,
                }}
              />
            </Card>
            <Card
              expandable
              exportTable
              app={app}
              exportContainer
              exportTableId={container[1].cards[1].nativeObject.id}
              header={{
                hardTitle: container[1].cards[1].title.hardTitle,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key={container[1].cards[1].nativeObject.valueId}
                reference={{
                  id: container[1].cards[1].nativeObject.id,
                }}
              />
            </Card>
            <Card
              expandable
              exportTable
              app={app}
              exportContainer
              exportTableId={container[1].cards[2].nativeObject.id}
              header={{
                hardTitle: container[1].cards[2].title.hardTitle,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key={container[1].cards[2].nativeObject.valueId}
                reference={{
                  id: container[1].cards[2].nativeObject.id,
                }}
              />
            </Card>
          </CardWrapper>

          {/* Análise por Segmento */}
          <div style={{ width: "100%", paddingInline: "10px" }}>
            <ComboHeader
              reference={{ title: { hard: container[2].name } }}
            ></ComboHeader>
          </div>
          <CardWrapper customStyle={{ height: "30%" }}>
            <Card
              expandable
              exportTable
              app={app}
              exportContainer
              exportTableId={container[2].cards[0].nativeObject.id}
              header={{
                hardTitle: container[2].cards[0].title.hardTitle,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key={container[2].cards[0].nativeObject.valueId}
                reference={{
                  id: container[2].cards[0].nativeObject.id,
                }}
              />
            </Card>
            <Card
              expandable
              exportTable
              app={app}
              exportContainer
              exportTableId={container[2].cards[1].nativeObject.id}
              header={{
                hardTitle: container[2].cards[1].title.hardTitle,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key={container[2].cards[1].nativeObject.valueId}
                reference={{
                  id: container[2].cards[1].nativeObject.id,
                }}
              />
            </Card>
            <Card
              expandable
              exportTable
              app={app}
              exportContainer
              exportTableId={container[2].cards[2].nativeObject.id}
              header={{
                hardTitle: container[2].cards[2].title.hardTitle,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key={container[2].cards[2].nativeObject.valueId}
                reference={{
                  id: container[2].cards[2].nativeObject.id,
                }}
              />
            </Card>
          </CardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

ManagementDesktop.defaultProps = {
  app: null,
  config: {},
};

ManagementDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default ManagementDesktop;
